import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaintbrush16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPaintbrush16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Paintbrush16)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m13.243 4.172-1.415 1.414-1.414-1.414 1.415-1.415a1 1 0 1 1 1.414 1.415m-3.536-.708 1.414-1.414a2 2 0 1 1 2.829 2.83l-1.414 1.414.707.707a2 2 0 0 1 0 2.828l-1.415 1.415a1 1 0 0 1-1.414 0L7.586 14.07a1 1 0 0 1-1.414 0L1.929 9.828a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 0-1.414l1.415-1.415a2 2 0 0 1 2.828 0zM11.828 7l-.707-.707-1.414-1.414L9 4.172l-.707-.708a1 1 0 0 0-1.414 0L5.465 4.88l.707.707 4.242 4.242.707.708 1.415-1.415a1 1 0 0 0 0-1.414zM2.637 9.121l2.829-2.828 4.242 4.243-2.828 2.828-.707-.707 1.414-1.414a.5.5 0 1 0-.707-.707L5.465 11.95 4.05 10.536l.001-.002 1.06-1.06a.5.5 0 1 0-.707-.706l-1.06 1.06z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Paintbrush16">
                        <path fill="#fff" d="M0 0h16v16H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPaintbrush16);
